import {inject, Injectable} from '@angular/core';
import {ProductCardsDefectValuesApiService} from "../services-api/product-cards-defect-values-api.service";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {
  CreateProductCardsDefectValueParams,
  ProductCardDefectValue,
  UpdateProductCardsDefectValueParams
} from "../types/product-card-defect.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardsDefectValuesService {
  private productCardsDefectValuesApiService: ProductCardsDefectValuesApiService = inject(ProductCardsDefectValuesApiService);

  public getProductCardsDefectValues(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardDefectValue>> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectValuesApiService.getProductCardsDefectValues(queryParams).subscribe({
        next: (productCardDefectValues) => resolve(productCardDefectValues),
        error: (error) => reject(error)
      });
    });
  }

  public createProductCardsDefectValue(createProductCardsDefectValueParams: CreateProductCardsDefectValueParams): Promise<ProductCardDefectValue> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectValuesApiService.createProductCardsDefectValue(createProductCardsDefectValueParams).subscribe({
        next: (productCardDefectValue) => resolve(productCardDefectValue),
        error: (error) => reject(error)
      });
    });
  }

  public updateProductCardsDefectValue(updateProductCardsDefectValueParams: UpdateProductCardsDefectValueParams): Promise<ProductCardDefectValue> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectValuesApiService.updateProductCardsDefectValue(updateProductCardsDefectValueParams).subscribe({
        next: (productCardDefectValue) => resolve(productCardDefectValue),
        error: (error) => reject(error)
      });
    });
  }

  public deleteProductCardsDefectValue(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectValuesApiService.deleteProductCardsDefectValue(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
